import { PropsWithChildren, ReactNode } from "react";
import clsx from "clsx";

import styles from "./PublicLayout.module.css";

type Size = "sm" | "md" | "lg" | "xl";

export interface Props {
  title?: string;
  className?: string;
  footer?: ReactNode;
  size?: Size;
}

const PublicLayout = ({
  title = "Lens ID",
  className = "",
  size = "lg",
  footer,
  children
}: PropsWithChildren<Props>) => (
  <div className={clsx("lds-web", styles.layout, className, size)}>
    <header>
      <h1>
        <img
          src="/static/media/lens-logo-icon.svg"
          aria-hidden
          alt="Lens"
        />
        <div>
          {title}
        </div>
      </h1>
    </header>
    <div className={styles.wrapper}>
      <main>{ children }</main>
      { footer && <footer role="contentinfo">{footer}</footer> }
    </div>
  </div>
);

export default PublicLayout;
